export const CONSTS = {
    EmailSent : "Email Sent",
    EmailOpened : "Email Opened",
    ClickedLink : "Clicked Link",
    SubmittedData : "Submitted Data",
    EmailReported : "Email Reported",


    CampaignInitialzied : "Initialized",
    CampaignInProgress : "In progress",
    CampaignDone : "Done",
    CampaignError : "Error",
}